import React from 'react';

import ImageWithGradient from 'components/ImageWithGradient';
import Message from 'components/Message';
import Typography from 'components/Typography';

import TopNavigation from 'containers/TopNavigation';

import { IntlMsgShape } from 'helpers/consts';

import CourseTotalDuration from '../CourseTotalDuration';
import './style.scss';

interface CourseHeaderProps {
  headerIllustration: {
    src: string;
    alt: IntlMsgShape;
  };
  title: IntlMsgShape;
  description: IntlMsgShape;
  numberOfAudios: number;
  totalCourseLength: string;
}

const CourseHeader = ({
  headerIllustration,
  title,
  description,
  numberOfAudios,
  totalCourseLength,
}: CourseHeaderProps) => {
  return (
    <div className="CourseHeader">
      <TopNavigation />
      <ImageWithGradient image={headerIllustration} />
      <div className="CourseHeader__info">
        <Typography variant="h1" centered>
          <Message message={title} />
        </Typography>
        <CourseTotalDuration
          totalCourseLength={totalCourseLength}
          numberOfAudios={numberOfAudios}
        />
        <Typography variant="body">
          <Message message={description} />
        </Typography>
      </div>
    </div>
  );
};

export default CourseHeader;
